module.exports = __webpack_public_path__ + "img/natural_oak_226m_list.07eb13c0.jpg";